module.exports = __webpack_public_path__ + "img/unauthorized_cover.dab2d9d6.png";